export default __webpack_public_path__ + "static/media/storefront.ad947d9b.jpg";